// src/app/LanguageSwitcher.js
'use client';

import { useLanguage } from './contexts/LanguageContext';
import { LANGUAGE_OPTIONS } from './constants/languages';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <select
      value={language}
      onChange={(e) => setLanguage(e.target.value)}
      className="bg-transparent text-white text-sm focus:outline-none appearance-none cursor-pointer"
    >
      {LANGUAGE_OPTIONS.map(({ code, name }) => (
        <option key={code} value={code} className="bg-[var(--background)] p-3 text-center">
          {name}
        </option>
      ))}
    </select>
  );
}
